import React, { useState } from "react";
import { useLanguage } from "../../i18n";
import { resolveUrl } from "../../api";

export function PhotoLightbox({
  photos,
  index,
  onClose,
}: {
  photos: string[];
  index: number;
  onClose: () => void;
}) {
  const { t } = useLanguage();
  const [i, setI] = useState(index);
  const prev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setI((cur) => (cur - 1 + photos.length) % photos.length);
  };
  const next = (e: React.MouseEvent) => {
    e.stopPropagation();
    setI((cur) => (cur + 1) % photos.length);
  };

  return (
    <>
      <div className="lightbox-backdrop" onClick={onClose} />
      <div className="lightbox" onClick={onClose}>
        <button className="lightbox-close" onClick={onClose} aria-label={t("photoLightbox.closeAria")}>
          ✕
        </button>
        <img className="lightbox-img" src={resolveUrl(photos[i])} alt="" onClick={(e) => e.stopPropagation()} />
        {photos.length > 1 && (
          <>
            <button className="lightbox-nav prev" onClick={prev} aria-label={t("photoLightbox.previousPhotoAria")}>
              ‹
            </button>
            <button className="lightbox-nav next" onClick={next} aria-label={t("photoLightbox.nextPhotoAria")}>
              ›
            </button>
            <div className="lightbox-count">
              {t("photoLightbox.countLabel", { current: i + 1, total: photos.length })}
            </div>
          </>
        )}
      </div>
    </>
  );
}
